import { useEffect, useState } from 'react';
import { ArrowIcon, ScrollTopIcon } from '../assets/icons';

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);
  const [iconColor, setIconColor] = useState('text-primary');
  const [arrowColor, setArrowColor] = useState('#000000'); // Default color

  const checkScrollTop = () => {
    const scrollY = window.scrollY;
    const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
    const scroll = (scrollY / totalHeight) * 100;
    setScrollProgress(scroll);
    setIsVisible(scrollY > 300);
    const footer = document.querySelector('footer');
    // const footerHeight = footer ? footer.offsetHeight : 0;
    const footerOffset = footer ? footer.offsetTop : 0;

    if (scrollY + window.innerHeight >= footerOffset) {
      setIconColor('text-gray-500'); 
      setArrowColor('#ffffff');
    } else {
      setIconColor('text-primary');
      setArrowColor('#000000'); 
    }
  };
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    window.addEventListener('scroll', checkScrollTop);
    return () => window.removeEventListener('scroll', checkScrollTop);
  }, []);

  return (
    <>
      {isVisible && (
        <div className="fixed bottom-5 right-8 md:right-8 sm:right-4 z-50 flex items-center justify-center">
          <ScrollTopIcon scrollProgress={scrollProgress} color={iconColor} />
          <button
            onClick={scrollToTop}
            className="relative z-10 p-3 font-bold text-2xl rounded-full text-primary"
          >
            <ArrowIcon color={arrowColor} />
            </button>
        </div>
      )}
    </>
  );
};

export default ScrollToTopButton;
